export const OSMOSIS_TIPO_IDS = [21]
